import React, { Component } from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import { multiLanguage } from "../../hoc";

@multiLanguage()
export default class Faq extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired
  };
  state = {
    currentCategoryId: 1,
    showAnswerId: 0
  };
  render() {
    const { t, category, faqs, currentLanguage } = this.props;
    const { currentCategoryId, showAnswerId } = this.state;
    const faqId = _.filter(faqs, ["categoryId", currentCategoryId]);
    return (
      <div className="section-faq">
        <div className="container">
          <div className="row section-name">
            <h2>{t("FAQ")}</h2>
          </div>
          <div className="row container-faq">
            <div className="col-xl-3 col-lg-10">
              <ul className="ul-faq-title">
                {_.map(category, value => {
                  const isInclude = _.includes(
                    value.displayOn,
                    currentLanguage
                  );
                  if (isInclude){
                    return (
                      <li
                        key={value.id}
                        className={`title-faq ${
                          value.id === currentCategoryId ? "active" : ""
                        }`}
                        onClick={() =>
                          this.setState({
                            currentCategoryId: value.id,
                            showAnswerId: 0
                          })
                        }
                      >
                        {t(value.name)}
                      </li>
                    );
                  }
                  return null
                })}
              </ul>
            </div>
            <div className="col-xl-8 col-lg-10">
              <ul>
                {_.map(faqId, (value, key) => {
                  const isInclude = _.includes(
                    value.displayOn,
                    currentLanguage
                  );
                  if (value.categoryId === currentCategoryId && isInclude) {
                    return (
                      <li className="question-faq" key={key}>
                        <h3
                          onClick={() =>
                            this.setState({
                              showAnswer: true,
                              showAnswerId: key
                            })
                          }
                        >
                          {t({
                            en: "Q.",
                            cn: "问.",
                            ru: "B."
                          })}
                          {t(value.question)}
                        </h3>
                        <div
                          className={`answer-faq ${
                            showAnswerId === key ? "show-answer" : ""
                          }`}
                        >
                          {t(value.answer)}
                        </div>
                      </li>
                    );
                  }
                })}
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/common/Faq.js